export class Sex{
    id?: number;
    name?: string;
}
